import Vue from 'vue';
import InfowindowMarker from '../../components/InfowindowMarker.vue';
import InfowindowLine from '../../components/InfowindowLine.vue';
let map;
let osmurl = 'https://webrd04.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}';
// "http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetGray/MapServer/tile/{z}/{y}/{x}";
export const initMap = function(mapUrl) {
  map = L.map('mapContainer', {
    center: [39.908808, 116.397389],
    // center: [31.238279, 121.484078],
    zoom: 13,
    minZoom: 1,
    maxZoom: 18,
    projection: L.Projection.LonLat,
    attributionControl: false,
    zoomControl: false
  });
  if (mapUrl) osmurl = mapUrl;
  L.tileLayer(osmurl).addTo(map);
  L.control
    .zoom({
      position: 'bottomright',
      zoomInTitle: '放大',
      zoomOutTitle: '缩小'
    })
    .addTo(map);
  L.control
    .scale({
      imperial: false
    })
    .addTo(map);
  return map;
};
export const openMarWindow = function(marker, data, map) {
  let InfoWindow = new Vue({
    ...InfowindowMarker,
    parent: this,
    propsData: {
      data
    }
  }).$mount();
  let popup = new L.Popup({
    minWidth: 336,
    className: 'dt-infowindow'
  })
    .setLatLng(marker.latlng)
    .setContent(InfoWindow.$el)
    .addTo(map);
};
export const openLineWindow = function(line, data, map) {
  let InfoWindow = new Vue({
    ...InfowindowLine,
    parent: this,
    propsData: {
      data
    }
  }).$mount();
  let popup = new L.Popup({
    minWidth: 336,
    className: 'dt-infowindow'
  })
    .setLatLng(line.latlng)
    .setContent(InfoWindow.$el)
    .addTo(map);
};



// WEBPACK FOOTER //
// ./src/assets/javascript/map.js